<template>
  <div class="welcome-henan">
    <div class="welcome-container">
      <div class="title-bar">
        <h2 class="font-white site-title">
          {{$store.getters.sysConfigs['TITLE']}}
        </h2>
        <div class="addons">
          <a href="./" class="addon-link">使用说明</a>
          <a href="./" class="addon-link">联系我们</a>
        </div>
      </div>
      <div class="login-area">
        <div class="entries">
          <div class="entry red" @click="$router.push({name:'Login',query:{mode:'henan'}})">
            <div class="title">监管人登录</div>
            <div class="icon"><Icon type="ios-desktop" /></div>
          </div>
          <div class="entry green" @click="$router.push({name:'Login',query:{mode:'henan'}})">
            <div class="icon"><Icon type="ios-person" /></div>
            <div class="title">经办机构登录</div>
          </div>
          <div class="entry blue" @click="$router.push('/verify')">
            <div class="title">保函验真</div>
            <div class="icon"><Icon type="ios-search" /></div>
          </div>
          <div class="entry yellow" @click="$router.push('/published')">
            <div class="icon"><Icon type="ios-people" /></div>
            <div class="title">经办机构名录</div>
          </div>
        </div>
      </div>
      <Footer class="footer" :style="{padding: '5px 0px', color: '#ccc', fontSize: '12px'}" />
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default {
  name: 'login',
  components: {
    Footer
  },
  data () {
    return {
      loading: false
    }
  },
  created () {
  },
  mounted () {
    let backImgUrl = this.$store.getters.sysConfigs['WELCOME_BACKGROUND_IMAGE_URL'] || 'bg_01.jpg'
    if (backImgUrl && backImgUrl.toLowerCase().indexOf('http') === 0) {
      backImgUrl = `url(${backImgUrl})`
    } else {
      backImgUrl = `url('/static/'${backImgUrl})`
    }
    document.querySelector('.welcome-henan').style.backgroundImage = backImgUrl
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.welcome-henan {
  height: 100vh;
  background-color: #f2f2f2;
  overflow: hidden;
  color: #efefef;
  background-image: url('./../assets/01.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .welcome-container {
    .title-bar {
      width: 100%;
      position: absolute;
      top: 0;
      background: @primaryColor;
      padding: 12px 32px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .site-title {
      }
      .addons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .addon-link {
          color: #e2e2e2;
          padding: 0 10px;
          &:hover {
            color: #fff;
          }
        }
      }
    }
    
    position: relative;
    z-index: 100;
    padding: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .login-area {
    position: relative;
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    // justify-content: center;
  }
  .entries{
    width: 380px;
    position: relative;
    left: 20%;
    display: flex;
    flex-direction: column;
    .entry {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      width: 100%;
      margin-bottom: 6px;
      opacity: 0.82;
      transition: all .3s linear;
      cursor: pointer;
      .title {
        height: 120px;
        background: @primaryColor;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        font-size: 24px;
        font-weight: bold;
      }
      .icon {
        padding: 0 40px;
        border: 2px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 36px;
        background: rgba(255,255,255,.5);
        transition: all .3s linear;
        color: #fff;
      }
      :last-child{
        margin-left: 6px;
      }
      &:hover {
        opacity: 1;
        .icon {
          background: rgba(255,255,255,0);
        }
      }
      &.red {
        .title {
          background: linear-gradient(to bottom, rgb(255, 31, 31), rgb(131, 12, 12));
        }
        .icon {
          // color: rgb(255, 31, 31);
        }
      }
      &.green {
        .title {
          background: linear-gradient(to bottom, rgb(23, 245, 97), rgb(3, 122, 63));
        }
        .icon {
          // color: rgb(23, 245, 97);
        }
      }
      &.blue {
        .title {
          background: linear-gradient(to bottom, rgb(23, 182, 245), rgb(2, 62, 141));
        }
        .icon {
          // color: rgb(23, 182, 245);
        }
      }
      &.yellow {
        .title {
          background: linear-gradient(to bottom, rgb(241, 245, 23), rgb(180, 98, 4));
        }
        .icon {
          // color: rgb(23, 182, 245);
        }
      }
    }
  }
  
  .footer {
    position: absolute;
    bottom: 5px;
    left: 5px;
  }
}

</style>
